/* Fanger window.fetch i vinduet mellom Shopifys instrumentering og Versio-appen.
   Dette scriptet lastes med defer og ligger foer app-scriptet i dokumentet.
   Deferred scripts kjoerer i dokumentrekkefoelge, saa dette kjoerer foerst.
   Formaal: kunne legge i handlekurven slik at Shopifys pixel ser kallet,
   uten at bundle-appen rekker aa snylte paa det med sine egne varer. */
(function () {
  try {
    window.__filFetchNativ = /\[native code\]/.test(String(window.fetch));
    window.__filFetch = window.fetch;
    window.__filFetchSatt = true;
  } catch (e) {
    window.__filFetchSatt = false;
  }
})();
